import { render, staticRenderFns } from "./DispatchSummaryHeader.vue?vue&type=template&id=dc4a4fc0&scoped=true"
import script from "./DispatchSummaryHeader.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryHeader.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryHeader.vue?vue&type=style&index=0&id=dc4a4fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4a4fc0",
  null
  
)

export default component.exports